<template>

  <div class="property" :style="`width: ${width};`">
    <h6 v-if="name != ''" :style="`min-width: ${name_width};`">{{ name }}:</h6>
    <h6 v-if="name_applicant != ''" :style="`min-width: ${name_width};`"> Applicant {{ name_applicant }} Employee Type :</h6>
    <div :class="{right: right}">
      <slot></slot>
    </div>
  </div>

</template>
<script>
export default {
  name: "property-view",
  props: {
    name: {
      type: String,
      default: "",
    },
    name_width: {
      type: String,
      default: '80px',
    },
    width: {
      type: String,
      default: '225px',
    },
    right: {
      type: Boolean,
      default: false,
    },
    name_applicant: {
      type: String|Number,
      default: "",
    },
  },
};
</script>
<style scoped lang="scss">
  @import "../../assets/scss/theme.scss";

  h6{
    font-weight: bold;
    font-size: 11px;
    color:  rgba(0,0,0,0.6);
  }
  .property{
    display: inline-block;
    vertical-align: top;
  }
  .property > *{
    display: inline-block;
    vertical-align: top;
    margin-right: 10px;
  }
  .property > h6{
    margin-top: 4px;
  }
  .property > .right{
    float: right;
  }
</style>
